class History {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    const grayLineHeight = document.querySelector(".gray-line").offsetHeight
    const redLine = document.querySelector(".red-line")
    let percentage;


    gsap.to('.js-target', {

      scrollTrigger: {
        trigger: '.js-redLine-start',
        start: 'top =+60',
        end: grayLineHeight,
        // markers: true,
        scrub: true,
        onEnter: () => {
          redLine.style.height = "0px"
        },
        onUpdate:(self)=>{
          percentage = self.progress.toLocaleString( undefined, { maximumFractionDigits:3 })*100;
          redLine.style.height = `${percentage}%`
        }
      }
    });


    const yearDots = document.querySelectorAll(".js-list-content")
    const yearMenu = document.querySelectorAll(".year-time");


    // 対象のエレメント
    // optionは省略可能、初期値は以下のようになります。
    const option = {
        root: null,
        rootMargin: "-100px",
        threshold: [0]
    };

    yearDots.forEach((dot,i) => {
      // 交差した際の処理を記載
      const callback = function (entries, observer) {
          entries.forEach(function (entry) {
            // 交差している場合はtrue
            if (entry.isIntersecting) {
                  // 処理実行
                  // 処理完了後、監視を止めたい場合
                  if(yearMenu[i]){
                    yearMenu.forEach((menu) => {
                      menu.classList.remove("is-active")
                    })
                    yearMenu[i].classList.add("is-active")
                  }else{

                  }


              }
          });
      };
      const observer = new IntersectionObserver(callback, option); // callback, optionを設定
      observer.observe(dot); // 監視を開始
    })



    $(function(){
      // #で始まるa要素をクリックした場合に処理（"#"←ダブルクォーテンションで囲むのを忘れずに。忘れるとjQueryのバージョンによっては動かない。。）
      $('a[href^="#"]').click(function(){
        // 移動先を0px調整する。0を30にすると30px下にずらすことができる。
        if (window.matchMedia('(min-width: 768px)').matches) {
          /* ウィンドウサイズ668以下の処理を記述 */
          var adjust = -200;
        }else{
          var adjust = -80;
        }

        // スクロールの速度（ミリ秒）
        var speed = 300;
        // アンカーの値取得 リンク先（href）を取得して、hrefという変数に代入
        var href= $(this).attr("href");
        // 移動先を取得 リンク先(href）のidがある要素を探して、targetに代入
        var target = $(href == "#" || href == "" ? 'html' : href);
        // 移動先を調整 idの要素の位置をoffset()で取得して、positionに代入
        var position = target.offset().top + adjust;
        // スムーススクロール linear（等速） or swing（変速）
        $('body,html').animate({scrollTop:position}, speed, 'swing');


        setTimeout(() => {
          $(this).parent().addClass("is-active");
          $('a[href^="#"]').not(this).parent().removeClass("is-active");
        }, 500);

        return false;



      });
    });


  }
}
